import { Skeleton } from "@mui/material";
import CommonPage from "../../components/common-page";
import useLanguage from "../../hooks/useLanguage";
import { BodyWrapper } from "./style";

export default function PlayerSkeleton() {
  const [
    {
      pages: { player: text },
    },
  ] = useLanguage();

  return (
    <CommonPage title={text.title} subtitle={text.subtitle}>
      <BodyWrapper>
        <Skeleton
          variant="rounded"
          sx={{ maxWidth: 480, width: "100%", height: "80%" }}
        />
      </BodyWrapper>
    </CommonPage>
  );
}
